import { Observable } from 'rxjs';
import { ApiResponseModel, EmailAcknowledgeStatusModel, EmailAcknowledgeRequestModel } from '@grabbill/lib';

export abstract class EmailAcknowledgementApi {
  abstract getStatus(token: string): Observable<ApiResponseModel<EmailAcknowledgeStatusModel>>;

  abstract acknowledge(
    request: EmailAcknowledgeRequestModel
  ): Observable<ApiResponseModel<EmailAcknowledgeStatusModel>>;
}
